// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"572":"9853c586","1728":"717a27ca","6962":"717a27ca","7331":"717a27ca","7404":"717a27ca"}[chunkId] + ".chunk.css";
};